import { render, staticRenderFns } from "./inventoryList.vue?vue&type=template&id=40a16c9a&scoped=true&"
import script from "./inventoryList.vue?vue&type=script&lang=js&"
export * from "./inventoryList.vue?vue&type=script&lang=js&"
import style0 from "./inventoryList.vue?vue&type=style&index=0&id=40a16c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a16c9a",
  null
  
)

export default component.exports